.root {
    composes: repeater from "../../styles/layout.module.scss";
    margin: var(--spacer-40) 0;
}

// Column spans, keyed by the block's `size` choice. Applied to both the image
// and the caption so they share a left edge.
.text {
    composes: col6 from "../../styles/layout.module.scss";
}

.wide {
    composes: col10 from "../../styles/layout.module.scss";
}

.full {
    composes: fullwidth from "../../styles/layout.module.scss";
}

.image {
    picture {
        display: block;
    }

    // max-width (not width) so small raster images aren't upscaled and blurred
    img {
        display: block;
        max-width: 100%;
        height: auto;
        margin-inline: auto;
    }
}

// SVGs are resolution-independent, so let them fill the column
.vector img {
    width: 100%;
}

.caption {
    max-width: 70ch;
    margin-top: var(--spacer-12);
    color: var(--dark-gray);
}

.captionText {
    composes: fontP14 from "../../styles/typography.module.scss";
    margin: 0;

    & + & {
        margin-top: var(--spacer-8);
    }
}
